export const lazyLoadOffset = 500;
